// Modelo Dinamico para monitoreo.

//TIPO 0: Solo LABEL
//{valor:"", descripcion:"", tipo:0 ,label:"g. Exposiciones en trabajos anteriores (ver HCU):",label2:"Tipo Detalle"},

//TIPO 1: select con opciones
//{valor:"", descripcion:"", tipo:1 ,label:"a. Datos de filiación:" ,data:["SI","NO"]},

//TIPO 2: Select con opciones y un campo con descripcion
//{valor:"", descripcion:"", valor2:"", tipo:2 ,label:"Discoteca:",data:["SI","NO"],label2:"veces/mes"},

//TIPO 3: Campo para observaciones inputText
//{valor:"", descripcion:"", tipo:3 ,label:"Valor:"},

//TIPO 4: Campo para observaciones textArea
//{valor:"", descripcion:"", tipo:4 ,label:"Valor:"},

export default class MonitoreoOftalmologicoCs {
    fecha={}
    lista=[
        {
            encabezado:"1. Información personal y laboral",
            datos:[
                {valor:"", descripcion:"", tipo:20 ,label:"a. Datos de filiación:", bold:false},
                {valor:"", descripcion:"", tipo:21 ,label:"      C.I.: 1721930442", bold:false},
                {valor:"", descripcion:"", tipo:22 ,label:"      Edad: 32", bold:false},
                {valor:"", descripcion:"", tipo:23 ,label:"      Apellidos y nombres: LOPEZ CRISTIAN", bold:false},
                {valor:"", descripcion:"", tipo:24 ,label:"      Empresa: PRIVADOS", bold:false},
                {valor:"", descripcion:"", tipo:25 ,label:"      Puesto de trabajo: PRIVADO", bold:false},
                {valor:"", descripcion:"", tipo:1 ,label:"b. ¿En su lugar de trabajo, trabaja en pantalla de visualización de datos (PVD)?" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"c. Si la respuesta es afirmativa, indicar el tiempo al día:",data:["< 2 horas","De 2 a 4 horas","> 4 horas","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"d. ¿El trabajo (tarea) exige mirar detalles pequeños de objetos o de letras?" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"e. Si la respuesta es afirmativa, indicar el tiempo al día:",data:["< 2 horas","De 2 a 4 horas","> 4 horas","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"f. ¿Mira la televisión todos los días más dos horas?" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"g. En sus tareas ¿hay procesos mecánicos con proyección de partículas o fragmentos sólidos (cuerpos extraños para los ojos)?" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"h. En su trabajo ¿está expuesto a solventes orgánicos. metales pesados, plaguicidas?" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"i. En su trabajo ¿está expuesto a radiaciones no ionizantes (infrarojas, ultravioletas)?" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"j. En su trabajo ¿Usa elementos de protección EPP?" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Especificar:"},
                {valor:"", descripcion:"", tipo:1 ,label:"k. En su trabajo ¿existe mala iluminación?" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"l. Luxometria (valoración instrumental migrada de HCU)"},
            ]
        },
        {
            encabezado:"2. Antecedentes visuales y oculares",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"a. Conjuntivitis:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"b. Problemas de refracción:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:0 ,label:"c. Si la respuesta es positiva, especifique:"} ,
                {valor:"", descripcion:"", tipo:3 ,label:"Ojo derecho:"},
                {valor:"", descripcion:"", tipo:3 ,label:"Ojo izquierdo:"},
                {valor:"", descripcion:"", tipo:1 ,label:"d. Catarata:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"e. Uveítis:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"f. Otros:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Especificar: ejemplo pterigium, queratitis, etc" },
                {valor:"", descripcion:"", tipo:1 ,label:"g. Cirugía en ojos:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"h. Si la respuesta es positiva, especifique:" },
                {valor:"2018-03-02", descripcion:"", tipo:12 ,label:"i. Fecha de último examen oftalmológico:" },
                {valor:"", descripcion:"", tipo:1 ,label:"j. Uso de lentes de corrección:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"k. Si la respuesta es positiva, indique tipo y tiempo:" },
            ]
        },
        {
            encabezado:"3. Antecedentes patológicos generales (HCU)",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"Hipertensión arterial" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Diabetes" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Otras metabólicas y degenerativas" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Mentales" ,data:["SI","NO"]},
            ]
        },
        {
            encabezado:"4. Antecedentes de familiares cercanos (Padre, madre, hermanos) con patología ocular o visual",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"a. Retinopatía:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"b. Glaucoma:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"c. Ametropías:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"d. Discromatopsias:" ,data:["SI","NO"]},
            ]
        },
        {
            encabezado:"5. Sintomatología actual",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"a. Visión borrosa:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"b. Visión doble:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"c. Ve estrellitas o luces:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"d. Dificultad en la distinción de los colores:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"e. Lagrimeo:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"f. Ardor o picazón en los ojos:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"g. Enrojecimiento de los ojos:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"h. Dolor en los ojos:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"i. Aumento del parpadeo:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"j. Cefalea:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"k. Fotofobia:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"l. Hinchazón de los ojos:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"m. Vértigo:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"n. Somnolencia:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"o. Nerviosismo:" ,data:["SI","NO"]}
            ]
        },
        {
            encabezado:"6. ¿Se aplicó el cuestionario OSDI para determinación de ojo seco?",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Si la respuesta es positiva registrar el resultado:" }
            ]
        },
        {
            encabezado:"7. Ha recibido capacitaciones sobre ...",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"Problemas visuales-oculares por el trabajo" ,data:["Frecuentemente","Rara vez","Nunca"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Medidas de prevención y protección para los ojos" ,data:["Frecuentemente","Rara vez","Nunca"]},
            ]
        },
        {
            encabezado:"8. Conclusiones del estado de salud",
            datos:[
                {valor:"", descripcion:"", tipo:4 ,label:""},
            ]
        },
        {
            encabezado:"9. Recomendaciones en el campo de la salud (seguimiento, interconsulta, medidas de protección, capacitación).",
            datos:[
                {valor:"", descripcion:"", tipo:4 ,label:""},
            ]
        },
    ]
}
var today = new Date();
var dd = today.getDate();
var mm = today.getMonth() + 1; //January is 0!

var yyyy = today.getFullYear();
if (dd < 10) {
    dd = '0' + dd;
}
if (mm < 10) {
    mm = '0' + mm;
}
var today = dd + '/' + mm + '/' + yyyy;





// WEBPACK FOOTER //
// ./src/model/MonitoreoOftalmologicoCs.js